const API_URL = "https://api.themoviedb.org/3/";

export default API_URL;
